import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';

const AdminPage = () => {
  const [activeTab, setActiveTab] = useState('pending-firms');
  const [pendingFirms, setPendingFirms] = useState([]);
  const [pendingComments, setPendingComments] = useState([]);
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({ name: '', icon: '' });
  const [editingCategory, setEditingCategory] = useState(null);
  const [editingFirm, setEditingFirm] = useState(null);
  const [featuredFirms, setFeaturedFirms] = useState([]);
  const [allFirms, setAllFirms] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [pending, comments, cats, featured, firms] = await Promise.all([
        api.admin.getPendingFirms(),
        api.admin.getPendingComments(),
        api.getCategories(),
        api.getFeaturedFirms(),
        api.admin.getAllFirms?.() || []
      ]);
      setPendingFirms(pending);
      setPendingComments(comments);
      setCategories(cats);
      setFeaturedFirms(featured);
      setAllFirms(firms);
    } catch (error) {
      console.error('Error loading admin data:', error);
    }
  };

  const handleApproveFirm = async (firmId) => {
    try {
      await api.admin.approveFirm(firmId);
      alert('Firma onaylandı');
      loadData();
    } catch (error) {
      alert('Onaylama işlemi başarısız');
    }
  };

  const handleDisapproveFirm = async (firmId) => {
    try {
      await api.admin.disapproveFirm(firmId);
      alert('Firma reddedildi');
      loadData();
    } catch (error) {
      alert('Reddetme işlemi başarısız');
    }
  };

  const handleEditFirm = async (firmData) => {
    try {
      await api.admin.updateFirm?.(firmData.id, firmData);
      alert('Firma güncellendi');
      setEditingFirm(null);
      loadData();
    } catch (error) {
      alert('Güncelleme işlemi başarısız');
    }
  };

  const handleDeleteFirm = async (firmId) => {
    if (window.confirm('Bu firmayı silmek istediğinizden emin misiniz?')) {
      try {
        await api.admin.deleteFirm?.(firmId);
        alert('Firma silindi');
        loadData();
      } catch (error) {
        alert('Silme işlemi başarısız');
      }
    }
  };

  const handleAddCategory = async (e) => {
    e.preventDefault();
    if (!newCategory.name || !newCategory.icon) return;
    
    try {
      await api.admin.addCategory?.(newCategory);
      alert('Kategori eklendi');
      setNewCategory({ name: '', icon: '' });
      loadData();
    } catch (error) {
      alert('Kategori ekleme başarısız');
    }
  };

  const handleUpdateCategory = async (categoryData) => {
    try {
      await api.admin.updateCategory?.(categoryData.id, categoryData);
      alert('Kategori güncellendi');
      setEditingCategory(null);
      loadData();
    } catch (error) {
      alert('Güncelleme işlemi başarısız');
    }
  };

  const handleDeleteCategory = async (categoryId) => {
    if (window.confirm('Bu kategoriyi silmek istediğinizden emin misiniz?')) {
      try {
        await api.admin.deleteCategory?.(categoryId);
        alert('Kategori silindi');
        loadData();
      } catch (error) {
        alert('Silme işlemi başarısız');
      }
    }
  };

  const handleToggleFeatured = async (firmId, isFeatured) => {
    try {
      if (isFeatured) {
        await api.admin.removeFromFeatured?.(firmId);
        alert('Firma öne çıkanlardan kaldırıldı');
      } else {
        await api.admin.addToFeatured?.(firmId);
        alert('Firma öne çıkanlara eklendi');
      }
      loadData();
    } catch (error) {
      alert('İşlem başarısız');
    }
  };

  const headerStyle = {
    background: 'linear-gradient(135deg, var(--navy-blue) 0%, var(--baby-blue) 100%)',
    color: 'var(--white)',
    padding: '40px 0',
    textAlign: 'center'
  };

  const tabsStyle = {
    display: 'flex',
    borderBottom: '2px solid var(--gray-200)',
    marginBottom: '32px',
    overflowX: 'auto'
  };

  const tabStyle = {
    padding: '12px 24px',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: 'Comfortaa, cursive',
    fontWeight: '500',
    fontSize: '14px',
    whiteSpace: 'nowrap',
    borderBottom: '3px solid transparent',
    transition: 'all 0.3s ease'
  };

  const activeTabStyle = {
    ...tabStyle,
    color: 'var(--navy-blue)',
    borderBottomColor: 'var(--baby-blue)'
  };

  const cardStyle = {
    background: 'var(--white)',
    borderRadius: '12px',
    padding: '24px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
    marginBottom: '24px'
  };

  const buttonGroupStyle = {
    display: 'flex',
    gap: '8px',
    marginTop: '16px',
    flexWrap: 'wrap'
  };

  const modalStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '20px'
  };

  const modalContentStyle = {
    background: 'var(--white)',
    borderRadius: '12px',
    padding: '32px',
    maxWidth: '600px',
    width: '100%',
    maxHeight: '80vh',
    overflow: 'auto'
  };

  const tabs = [
    { id: 'pending-firms', label: 'Bekleyen Firmalar', count: pendingFirms.length },
    { id: 'all-firms', label: 'Tüm Firmalar', count: allFirms.length },
    { id: 'pending-comments', label: 'Bekleyen Yorumlar', count: pendingComments.length },
    { id: 'categories', label: 'Kategoriler', count: categories.length },
    { id: 'featured', label: 'Öne Çıkanlar', count: featuredFirms.length },
    { id: 'complaints', label: 'Şikayetler' },
    { id: 'contacts', label: 'İletişim Mesajları' }
  ];

  return (
    <div>
      {/* Header */}
      <section style={headerStyle}>
        <div className="container">
          <h1 style={{ fontSize: '32px', marginBottom: '16px', fontFamily: 'Comfortaa, cursive' }}>
            Admin Panel
          </h1>
          <p style={{ fontSize: '16px', opacity: 0.9 }}>
            Platform yönetimi ve içerik moderasyonu
          </p>
        </div>
      </section>

      <div className="container" style={{ padding: '40px 20px' }}>
        {/* Tabs */}
        <div style={tabsStyle}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={activeTab === tab.id ? activeTabStyle : tabStyle}
            >
              {tab.label}
              {tab.count !== undefined && (
                <span style={{
                  background: 'var(--baby-blue)',
                  color: 'var(--navy-blue)',
                  borderRadius: '12px',
                  padding: '2px 8px',
                  fontSize: '12px',
                  marginLeft: '8px'
                }}>
                  {tab.count}
                </span>
              )}
            </button>
          ))}
        </div>

        {/* Pending Firms Tab */}
        {activeTab === 'pending-firms' && (
          <div>
            <h2 style={{ fontSize: '24px', marginBottom: '24px', color: 'var(--navy-blue)', fontFamily: 'Comfortaa, cursive' }}>
              Onay Bekleyen Firmalar
            </h2>
            {pendingFirms.length === 0 ? (
              <div style={cardStyle}>
                <p style={{ textAlign: 'center', color: 'var(--gray-600)' }}>
                  Onay bekleyen firma bulunmuyor.
                </p>
              </div>
            ) : (
              pendingFirms.map(firm => (
                <div key={firm.id} style={cardStyle}>
                  <h3 style={{ fontSize: '20px', marginBottom: '12px', color: 'var(--navy-blue)' }}>
                    {firm.title}
                  </h3>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px', marginBottom: '16px' }}>
                    <div><strong>Kategori:</strong> {firm.kategori}</div>
                    <div><strong>Şehir:</strong> {firm.sehir}</div>
                    <div><strong>Telefon:</strong> {firm.kamuTelefon}</div>
                    <div><strong>E-posta:</strong> {firm.kamuEmail}</div>
                  </div>
                  <p style={{ marginBottom: '16px', color: 'var(--gray-600)' }}>
                    <strong>Hizmetler:</strong> {firm.services}
                  </p>
                  <p style={{ marginBottom: '16px', color: 'var(--gray-600)' }}>
                    <strong>Adres:</strong> {firm.acikAdres}
                  </p>
                  <div style={buttonGroupStyle}>
                    <button 
                      onClick={() => handleApproveFirm(firm.id)}
                      className="btn btn-primary"
                    >
                      ✅ Onayla
                    </button>
                    <button 
                      onClick={() => handleDisapproveFirm(firm.id)}
                      className="btn"
                      style={{ backgroundColor: '#dc2626', color: 'white' }}
                    >
                      ❌ Reddet
                    </button>
                    <button 
                      onClick={() => setEditingFirm(firm)}
                      className="btn btn-secondary"
                    >
                      ✏️ Düzenle
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        )}

        {/* All Firms Tab */}
        {activeTab === 'all-firms' && (
          <div>
            <h2 style={{ fontSize: '24px', marginBottom: '24px', color: 'var(--navy-blue)', fontFamily: 'Comfortaa, cursive' }}>
              Tüm Firmalar
            </h2>
            <div style={{ display: 'grid', gap: '16px' }}>
              {allFirms.map(firm => (
                <div key={firm.id} style={cardStyle}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '12px' }}>
                    <h3 style={{ fontSize: '18px', color: 'var(--navy-blue)' }}>{firm.title}</h3>
                    <span style={{
                      background: featuredFirms.some(f => f.id === firm.id) ? 'var(--baby-blue)' : 'var(--gray-200)',
                      color: featuredFirms.some(f => f.id === firm.id) ? 'var(--navy-blue)' : 'var(--gray-600)',
                      padding: '4px 8px',
                      borderRadius: '12px',
                      fontSize: '12px'
                    }}>
                      {featuredFirms.some(f => f.id === firm.id) ? '⭐ Öne Çıkan' : 'Normal'}
                    </span>
                  </div>
                  <div style={{ fontSize: '14px', color: 'var(--gray-600)', marginBottom: '12px' }}>
                    {firm.kategori} • {firm.sehir} • ⭐ {firm.puan}
                  </div>
                  <div style={buttonGroupStyle}>
                    <button 
                      onClick={() => setEditingFirm(firm)}
                      className="btn btn-secondary"
                      style={{ fontSize: '12px', padding: '6px 12px' }}
                    >
                      ✏️ Düzenle
                    </button>
                    <button 
                      onClick={() => handleToggleFeatured(firm.id, featuredFirms.some(f => f.id === firm.id))}
                      className="btn"
                      style={{ 
                        backgroundColor: featuredFirms.some(f => f.id === firm.id) ? '#f59e0b' : 'var(--baby-blue)',
                        color: 'white',
                        fontSize: '12px', 
                        padding: '6px 12px' 
                      }}
                    >
                      {featuredFirms.some(f => f.id === firm.id) ? '⭐ Kaldır' : '⭐ Öne Çıkar'}
                    </button>
                    <button 
                      onClick={() => handleDeleteFirm(firm.id)}
                      className="btn"
                      style={{ backgroundColor: '#dc2626', color: 'white', fontSize: '12px', padding: '6px 12px' }}
                    >
                      🗑️ Sil
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Categories Tab */}
        {activeTab === 'categories' && (
          <div>
            <h2 style={{ fontSize: '24px', marginBottom: '24px', color: 'var(--navy-blue)', fontFamily: 'Comfortaa, cursive' }}>
              Kategori Yönetimi
            </h2>
            
            {/* Add Category Form */}
            <div style={cardStyle}>
              <h3 style={{ fontSize: '18px', marginBottom: '16px', color: 'var(--navy-blue)' }}>
                Yeni Kategori Ekle
              </h3>
              <form onSubmit={handleAddCategory}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 100px auto', gap: '12px', alignItems: 'end' }}>
                  <div>
                    <label className="form-label">Kategori Adı</label>
                    <input
                      type="text"
                      value={newCategory.name}
                      onChange={(e) => setNewCategory({...newCategory, name: e.target.value})}
                      className="form-input"
                      placeholder="Örn: Restoran & Cafe"
                      required
                    />
                  </div>
                  <div>
                    <label className="form-label">İkon</label>
                    <input
                      type="text"
                      value={newCategory.icon}
                      onChange={(e) => setNewCategory({...newCategory, icon: e.target.value})}
                      className="form-input"
                      placeholder="🍽️"
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-primary">
                    Ekle
                  </button>
                </div>
              </form>
            </div>

            {/* Categories List */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px' }}>
              {categories.map(category => (
                <div key={category.id} style={cardStyle}>
                  {editingCategory?.id === category.id ? (
                    <div>
                      <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                        <input
                          type="text"
                          value={editingCategory.icon}
                          onChange={(e) => setEditingCategory({...editingCategory, icon: e.target.value})}
                          style={{ fontSize: '32px', textAlign: 'center', border: 'none', width: '60px' }}
                        />
                      </div>
                      <input
                        type="text"
                        value={editingCategory.name}
                        onChange={(e) => setEditingCategory({...editingCategory, name: e.target.value})}
                        className="form-input"
                        style={{ marginBottom: '16px' }}
                      />
                      <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                        <button 
                          onClick={() => handleUpdateCategory(editingCategory)}
                          className="btn btn-primary"
                          style={{ fontSize: '12px', padding: '6px 12px' }}
                        >
                          Kaydet
                        </button>
                        <button 
                          onClick={() => setEditingCategory(null)}
                          className="btn btn-secondary"
                          style={{ fontSize: '12px', padding: '6px 12px' }}
                        >
                          İptal
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                        <div style={{ fontSize: '32px', marginBottom: '8px' }}>{category.icon}</div>
                        <h3 style={{ fontSize: '16px', color: 'var(--navy-blue)' }}>{category.name}</h3>
                      </div>
                      <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                        <button 
                          onClick={() => setEditingCategory(category)}
                          className="btn btn-secondary" 
                          style={{ fontSize: '12px', padding: '6px 12px' }}
                        >
                          Düzenle
                        </button>
                        <button 
                          onClick={() => handleDeleteCategory(category.id)}
                          className="btn"
                          style={{ backgroundColor: '#dc2626', color: 'white', fontSize: '12px', padding: '6px 12px' }}
                        >
                          Sil
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Other tabs remain the same but simplified */}
        {activeTab === 'pending-comments' && (
          <div style={cardStyle}>
            <h2 style={{ fontSize: '24px', marginBottom: '24px', color: 'var(--navy-blue)', fontFamily: 'Comfortaa, cursive' }}>
              Bekleyen Yorumlar
            </h2>
            <p style={{ color: 'var(--gray-600)' }}>Yorum yönetimi yakında aktif olacak.</p>
          </div>
        )}

        {activeTab === 'featured' && (
          <div style={cardStyle}>
            <h2 style={{ fontSize: '24px', marginBottom: '24px', color: 'var(--navy-blue)', fontFamily: 'Comfortaa, cursive' }}>
              Öne Çıkan Firmalar
            </h2>
            <div style={{ display: 'grid', gap: '12px' }}>
              {featuredFirms.map(firm => (
                <div key={firm.id} style={{ padding: '12px', background: 'var(--light-blue)', borderRadius: '8px' }}>
                  <strong>{firm.title}</strong> - {firm.kategori}
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'complaints' && (
          <div style={cardStyle}>
            <h2 style={{ fontSize: '24px', marginBottom: '24px', color: 'var(--navy-blue)', fontFamily: 'Comfortaa, cursive' }}>
              Şikayetler
            </h2>
            <p style={{ color: 'var(--gray-600)' }}>Şikayet yönetimi yakında aktif olacak.</p>
          </div>
        )}

        {activeTab === 'contacts' && (
          <div style={cardStyle}>
            <h2 style={{ fontSize: '24px', marginBottom: '24px', color: 'var(--navy-blue)', fontFamily: 'Comfortaa, cursive' }}>
              İletişim Mesajları
            </h2>
            <p style={{ color: 'var(--gray-600)' }}>İletişim mesajları yakında aktif olacak.</p>
          </div>
        )}
      </div>

      {/* Edit Firm Modal */}
      {editingFirm && (
        <div style={modalStyle} onClick={() => setEditingFirm(null)}>
          <div style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ fontSize: '20px', marginBottom: '20px', color: 'var(--navy-blue)' }}>
              Firma Düzenle
            </h3>
            <div style={{ display: 'grid', gap: '16px' }}>
              <div>
                <label className="form-label">Firma Adı</label>
                <input
                  type="text"
                  value={editingFirm.title}
                  onChange={(e) => setEditingFirm({...editingFirm, title: e.target.value})}
                  className="form-input"
                />
              </div>
              <div>
                <label className="form-label">Hizmetler</label>
                <textarea
                  value={editingFirm.services}
                  onChange={(e) => setEditingFirm({...editingFirm, services: e.target.value})}
                  className="form-textarea"
                />
              </div>
              <div>
                <label className="form-label">Telefon</label>
                <input
                  type="tel"
                  value={editingFirm.kamuTelefon}
                  onChange={(e) => setEditingFirm({...editingFirm, kamuTelefon: e.target.value})}
                  className="form-input"
                />
              </div>
              <div>
                <label className="form-label">E-posta</label>
                <input
                  type="email"
                  value={editingFirm.kamuEmail || ''}
                  onChange={(e) => setEditingFirm({...editingFirm, kamuEmail: e.target.value})}
                  className="form-input"
                />
              </div>
              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                <button 
                  onClick={() => handleEditFirm(editingFirm)}
                  className="btn btn-primary"
                >
                  Kaydet
                </button>
                <button 
                  onClick={() => setEditingFirm(null)}
                  className="btn btn-secondary"
                >
                  İptal
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPage;